/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// eslint-disable-next-line no-unused-vars
import styles from "./DeleteCardModal.module.css";
import { useHotkey } from "../../../Utils/Hotkeys";
import BaseModal, { useBaseModal } from "../BaseModal/BaseModal";
import ModalCloseButton from "../ModalCloseButton/ModalCloseButton";

const propTypes = {
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  onDeleteCard: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  nested: PropTypes.bool,
};

const defaultProps = {
  onOpen: () => {},
  onClose: () => {},
  loading: false,
  nested: false,
};

const useDeleteCardModal = ({
  onOpen,
  onClose,
  onDeleteCard,
  loading,
  nested,
}) => {
  const { isOpened, open, close } = useBaseModal({
    onOpen,
    onClose,
    isNested: nested,
  });
  const [card, setCard] = useState(null);

  let content = null;
  if (isOpened) {
    content = (
      <DeleteCardModal
        show={isOpened}
        onCloseHandler={close}
        card={card}
        onDeleteHandler={onDeleteCard}
        deleteLoading={loading}
        nested={nested}
      />
    );
  }

  const openModal = (cardToDelete) => {
    setCard(cardToDelete);
    open();
  };

  const closeModal = () => {
    close();
    setCard(null);
  };

  return { open: openModal, close: closeModal, content };
};

useDeleteCardModal.propTypes = propTypes;
useDeleteCardModal.defaultProps = defaultProps;

const propTypesModal = {
  show: PropTypes.bool.isRequired,
  card: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string,
  }).isRequired,
  deleteLoading: PropTypes.bool.isRequired,
  onDeleteHandler: PropTypes.func.isRequired,
  onCloseHandler: PropTypes.func.isRequired,
  nested: PropTypes.bool,
};

const defaultPropsModal = {
  nested: false,
};

const DeleteCardModal = ({
  show,
  nested,
  card,
  deleteLoading,
  onDeleteHandler,
  onCloseHandler,
}) => {
  const { t } = useTranslation();
  const text = t("wisdomtree.modal_delete_card.text");

  useHotkey({
    keyNames: ["Enter"],
    callback: () => {
      if (!show) return;
      onDeleteHandler(card);
    },
    dependsOn: [onDeleteHandler, show],
  });

  useHotkey({
    keyNames: ["Escape"],
    callback: () => {
      if (!show) return;
      onCloseHandler();
    },
    dependsOn: [onCloseHandler, show],
  });

  return (
    <BaseModal show={show} onCloseHandler={onCloseHandler} nested={nested}>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">
            {t("wisdomtree.modal_delete_card.title")}
          </p>
          <ModalCloseButton onClick={onCloseHandler} disabled={deleteLoading} />
        </header>
        <section className="modal-card-body">
          <p>{text}</p>
        </section>
        <footer className="modal-card-foot">
          <button
            className={`button is-danger ${deleteLoading ? `is-loading` : ``}`}
            type="submit"
            onClick={() => {
              onDeleteHandler(card);
            }}
          >
            {t("wisdomtree.modal_delete_card.delete")}
          </button>
          <button
            className="button"
            type="button"
            onClick={onCloseHandler}
            disabled={deleteLoading}
          >
            {t("wisdomtree.modal_delete_card.cancel")}
          </button>
        </footer>
      </div>
    </BaseModal>
  );
};

DeleteCardModal.propTypes = propTypesModal;
DeleteCardModal.defaultProps = defaultPropsModal;

export default useDeleteCardModal;
